import {Alert, type AlertProps} from "@hosttools/frontend";
import type {FC} from "react";
import {useState} from "react";

export interface Props {
    actionType?: AlertProps["action"];
    actionText?: string;
    children?: React.ReactNode;
    action?: () => void;
    onClose?: (show: boolean) => void;
}
const Banner: FC<Props> = ({children, actionType = "info", actionText, action, onClose}) => {
    const [hide, setHide] = useState(false);

    function handleCloseError() {
        setHide(true);
        onClose?.(false);
    }

    if (hide) {
        return null;
    }

    return (
        <Alert
            action={actionType}
            primaryAction={action}
            primaryText={actionText}
            secondaryAction={handleCloseError}
            secondaryText="Dismiss"
            variant="banner"
        >
            {children}
        </Alert>
    );
};

export default Banner;
